import "@babel/polyfill";
import { tab_menu } from "./modules/tab-menu";
import { save_cookie } from "./modules/save-cookie";

// tab-menu
tab_menu();

// save-cookie
save_cookie();
